import React from 'react';
import ContentSection from './ContentSection';
import VideoWithModal from './VideoWithModal';

const StudentTestimonials = () => {
   
   return (
      <section className="py-12 md:py-16 lg:py-24 bg-light-5 transition-colors duration-300">
         <div className="container mx-auto px-4 sm:px-6 md:px-8 lg:px-[116px] py-4">
            <div className="flex flex-col lg:flex-row gap-8 lg:gap-32 items-center justify-start">
               {/* Video Section - Affichée en premier sur mobile */}
               <div className="w-full lg:w-7/12 order-first lg:order-last">
                  <VideoWithModal />
               </div>

               {/* Content Section - Affichée en second sur mobile */}
               <div className="w-full lg:w-5/12 order-last lg:order-first">
                  <ContentSection />
               </div>
            </div>
         </div>
      </section>
   );
};

export default StudentTestimonials;